function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div>
          <h2>Առք և Վաճառք</h2>
          <p>Գնիր, վաճառիր և գտիր այն, ինչ փնտրում ես։</p>
        </div>

        <div className="footer-copy">
          © {new Date().getFullYear()} Առք և Վաճառք. Բոլոր իրավունքները պաշտպանված են։
        </div>
      </div>
    </footer>
  );
}

export default Footer;